import React from "react";

import { twClassNames } from "@scripts/react/helpers/twClassNames";
import { Chip } from "@scripts/react/components/Chip";

interface ClickableElementProps {
    onClick: () => void;
    icon: string;
    title: string;
    description?: React.ReactNode;
    chip?: string | React.ReactNode;
    isSelected?: boolean;
    disabled?: boolean;
    className?: string;
    iconClassName?: string;
    titleClassName?: string;
    descriptionClassName?: string;
}

export const ClickableElement = ({
    onClick,
    icon,
    title,
    description,
    chip,
    isSelected = false,
    disabled = false,
    className,
    iconClassName,
    titleClassName,
    descriptionClassName
}: ClickableElementProps) => {
    const canHover = !disabled && !isSelected;

    return (
        <div
            onClick={disabled ? undefined : onClick}
            className={twClassNames(
                "border-border group flex cursor-pointer rounded-lg border bg-white px-5 py-4 transition-all duration-200",
                description ? "flex-col gap-2" : "items-center gap-4",
                isSelected && "border-brand bg-tint hover:bg-tint-hover",
                canHover && "hover:border-gray-400 hover:bg-gray-50",
                className,
                disabled && "cursor-not-allowed opacity-50"
            )}
        >
            <div className="flex items-center justify-between gap-2 text-base">
                <i
                    className={twClassNames(
                        icon,
                        "flex h-6 w-6 items-center justify-center",
                        isSelected ? "text-brand" : "text-primary",
                        canHover && "group-hover:text-secondary",
                        iconClassName
                    )}
                />
                {chip && (
                    // @ts-expect-error - Chip component type issue
                    <Chip color="purple" size="small">
                        {chip}
                    </Chip>
                )}
            </div>
            <div className="flex flex-col gap-0.5">
                <h3
                    className={twClassNames(
                        "text-base font-medium",
                        isSelected ? "text-brand" : "text-primary",
                        titleClassName
                    )}
                >
                    {title}
                </h3>
                {description && (
                    <p
                        className={twClassNames(
                            "text-sm",
                            isSelected ? "text-brand" : "text-tertiary",
                            canHover && "transition duration-200 group-hover:text-secondary",
                            descriptionClassName
                        )}
                    >
                        {description}
                    </p>
                )}
            </div>
        </div>
    );
};
